onReady(() => {
    const allLessonDetails = Array.from(document.querySelectorAll('body.ds .page-content .course-curriculum .lesson .details'));
    for (const lessonDetails of allLessonDetails) {
        lessonDetails.addEventListener('click', () => lessonDetails.parentElement.classList.toggle('open'))
    }
});
